module.exports = __webpack_public_path__ + "img/defaultAddress.29b22ca6.png";